<template>
  <div>
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="24">
        <el-col :span="4">
          <el-input placeholder="请输入姓名或手机号" v-model="queryInfo.cdit" clearable @clear="queryUserJobList"></el-input>
        </el-col>
        <el-col :span="5.5">
          <el-date-picker v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp" :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-col>
        <el-col :span="3">
          <el-button type="success" icon="el-icon-search" @click="queryUserJobList">搜索</el-button>
        </el-col>
        <el-col :span="4.5">
          <el-radio-group v-model="queryInfo.is_onjob" @change="queryUserJobList">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button :label="1">在职</el-radio-button>
            <el-radio-button :label="0">离职</el-radio-button>
          </el-radio-group>
        </el-col>
        <el-col :span="4.5">
          <el-radio-group v-model="queryInfo.status" @change="queryUserJobList">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button :label="1">正常</el-radio-button>
            <el-radio-button :label="0">删除</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>

      <!-- 用户列表区域 -->
      <el-table :data="tableData" stripe>
        <el-table-column prop="id" v-if="hide"></el-table-column>
        <el-table-column type="index" label="序号" min-width="80"></el-table-column>
        <el-table-column label="公司 部门 职位" min-width="250">
          <template slot-scope="scope">
            <div>{{scope.row.company_name}}</div>
            <div>{{scope.row.department_name}}</div>
            <div>{{scope.row.position_name}}</div>
          </template>
        </el-table-column>
        <el-table-column label="入职离职时间" min-width="175">
          <template slot-scope="scope">
            <div>入职：{{scope.row.from_dt | formatDate}}</div>
            <div>离职：{{scope.row.to_dt | formatDate}}</div>
          </template>
        </el-table-column>
        <el-table-column label="是否在职" min-width="80" align="center">
          <template slot-scope="scope">
            <span :style="scope.row.is_onjob =='在职'? 'color:#6FC334':'color:#EB5753'">{{scope.row.is_onjob}}</span>
          </template>
        </el-table-column>
        <el-table-column label="主账号" min-width="175" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button type="text" @click="specQuery(scope.row.user_phoneno)">
              <div style="text-align: left;line-height: 20px;">{{scope.row.user_name}}</div>
              <div style="text-align: left;line-height: 20px;">{{scope.row.user_phoneno}}</div>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="80">
          <template slot-scope="scope">
            <span :style="scope.row.status == '正常'?'color:#6FC334':'color:#EB5753'">{{scope.row.status}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="275">
          <template slot-scope="scope">
            <el-button-group>
              <el-button size="medium" type="warning" :disabled="scope.row.status == '删除' ? true :false" @click="showEditDialog(scope.row)">修改</el-button>
              <el-button size="medium" type="danger" :disabled="scope.row.status == '删除' ? true :false" @click="removeUserJobById(scope.row.id)">删除</el-button>
            </el-button-group>
            <el-button-group>
              <el-popover placement="bottom" width="200" trigger="click" style="margin-left: 8px">
                <span>{{scope.row.experience_desc}}</span>
                <el-button size="medium" slot="reference">经历描述</el-button>
              </el-popover>
            </el-button-group>

          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <div style="text-align: right">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.page_ix" :page-size="queryInfo.page_size" layout="prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </el-card>

    <!-- 添加用户的对话框 -->
    <el-dialog :title="formTitle" :visible.sync="dialogFormVisible" width="50%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="wordForm" ref="wordForm" label-width="70px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="wordForm.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phoneno">
          <el-input v-model="wordForm.phoneno" disabled></el-input>
        </el-form-item>
        <el-form-item label="公司名称" prop="company_name">
          <el-input v-model="wordForm.company_name"></el-input>
        </el-form-item>
        <el-form-item label="职位" prop="position_name">
          <el-input v-model="wordForm.position_name"></el-input>
        </el-form-item>
        <el-form-item label="部门" prop="department_name">
          <el-input v-model="wordForm.department_name"></el-input>
        </el-form-item>
        <el-form-item label="是否在职">
          <el-radio-group v-model="wordForm.is_onjob">
            <el-radio :label="1">在职</el-radio>
            <el-radio :label="0">离职</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="入职时间" prop="from_dt">
          <el-date-picker v-model="wordForm.from_dt" type="date" value-format="timestamp" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="离职时间" prop="to_dt">
          <el-date-picker v-model="wordForm.to_dt" type="date" value-format="timestamp" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="经历描述" prop="experience_desc">
          <el-input type="textarea" v-model="wordForm.experience_desc" placeholder="请输入经历"></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('wordForm',add_edit)">保存设置</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    // 验证手机号的规则
    var checkMobile = (rule, value, cb) => {
      // 验证手机号的正则表达式
      const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/

      if (regMobile.test(value)) {
        return cb()
      }

      cb(new Error('请输入合法的手机号'))
    }

    return {
      hide: false,
      value1: '',
      type: '',
      formTitle: '',
      add_edit: '',
      // 获取用户列表的参数对象
      queryInfo: {
        status: 1,
        is_onjob: '',
        cdit: '',
        from_dt: '',
        to_dt: '',
        // 当前的页数
        page_ix: 1,
        // 当前每页显示多少条数据
        page_size: 10
      },
      tableData: [],
      total: 10, // 分页总数
      // 控制添加用户对话框的显示与隐藏
      dialogFormVisible: false,
      // 用户的表单数据
      wordForm: {
        job_id: '',
        from_dt: '',
        to_dt: '',
        company_name: '',
        department_name: '',
        position_name: '',
        experience_desc: '',
        is_onjob: ''
      }
    }
  },
  created() {
    this.specQuery(this.$route.query.phone)
  },
  methods: {
    specQuery(phone = '') {
      this.queryInfo.cdit = phone
      this.queryUserJobList()
    },
    async queryUserJobList() {
      if (this.value1) {
        this.queryInfo.from_dt = Math.floor(this.value1[0] / 1000)
        this.queryInfo.to_dt = Math.floor(this.value1[1] / 1000)
      } else {
        this.queryInfo.from_dt = ''
        this.queryInfo.to_dt = ''
      }
      this.$axios.post('/admin/User/queryUserJob', this.queryInfo).then(res => {
        if (res.data.rst == 0) {
          this.tableData = res.data.data.data
          this.total = res.data.data.total
          this.tableData.forEach(e => {
            e.is_onjob = e.is_onjob == '1' ? '在职' : '离职'
            e.status = e.status == '1' ? '正常' : '删除'
          })
        } else {
          this.alertError(res.data.msg)
        }
      }).catch(err => {
        console.error('错误：', err)
      })
    },
    // 监听 page_size 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.page_size = newSize
      this.queryUserJobList()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      // console.log(newPage)
      this.queryInfo.page_ix = newPage
      this.queryUserJobList()
    },
    // 监听用户对话框的关闭事件
    addDialogClosed() {
      this.$refs.wordForm.resetFields()
    },
    // 展示编辑用户的对话框
    showEditDialog(row) {
      console.log('this.wordForm====', row)
      this.formTitle = '工作经历'
      this.add_edit = 'edit'
      this.dialogFormVisible = true
      Object.assign(this.wordForm, row)
      let std = row.is_onjob == '在职' ? 1 : 0
      let to_dt = row.to_dt * 1000
      let from_dt = row.from_dt * 1000
      this.wordForm.is_onjob = std
      this.wordForm.to_dt = to_dt
      this.wordForm.from_dt = from_dt
    },
    // 提交表单
    submitForm(formName, type) {
      // // 开启登录加载动画
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (type == 'edit') {
            console.log(' this.wordForm===', this.wordForm.is_onjob)
            // let sta = this.wordForm.is_onjob == "在职" ? 1 : 0;
            let editparams = {
              job_id: this.wordForm.id,
              from_dt: this.wordForm.from_dt / 1000,
              to_dt: this.wordForm.to_dt / 1000,
              company_name: this.wordForm.company_name,
              department_name: this.wordForm.department_name,
              position_name: this.wordForm.position_name,
              experience_desc: this.wordForm.experience_desc,
              is_onjob: this.wordForm.is_onjob
            }
            this.$axios.post('/admin/User/saveUserJob', editparams).then(res => {
              if (res.data.rst == 0) {
                this.alertSuccess(res.data.msg)
                this.queryUserJobList()
                this.dialogFormVisible = false
              } else {
                this.alertError(res.data.msg)
              }
            }).catch(err => {
              console.error('错误：', err)
            })
          }
        } else {
          return false
        }
      })
    },
    // 根据Id删除对应的用户信息
    async removeUserJobById(id) {
      // 弹框询问用户是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将删除所选内容, 是否继续?',
        '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)

      // 如果用户确认删除，则返回值为字符串 confirm
      // 如果用户取消了删除，则返回值为字符串 cancel
      // console.log(confirmResult)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      let editparams = {
        job_id: id,
        status: this.queryInfo.status
      }
      this.$axios.post('/admin/User/removeUserJob', editparams).then(res => {
        if (res.data.rst == 0) {
          this.alertSuccess(res.data.msg)
          this.queryUserJobList()
        } else {
          this.alertError(res.data.msg)
        }
      }).catch(err => {
        console.error('错误：', err)
      })
    },
    // 成功弹窗
    alertSuccess(msg) {
      this.$message.success({
        showClose: true,
        duration: 1000,
        message: msg,
        type: 'success'
      })
    },
    // 错误消息
    alertError(msg) {
      this.$message.error({
        duration: 1000,
        showClose: true,
        message: msg,
        type: 'error'
      })
    }
  }

}
</script>

<style lang="less" scoped>

</style>
